export const AI_BOT = "bot";
export const AGENT = "agent";
export const END_USER = "endUser";
export const SYSTEM = "system";
export const ANONYMOUS_USER = "ANONYMOUS";
export const PUBLIC_ACCESS = "public";
